import React from 'react';

export default function Flande(props) {
  return (
    <div className={(props.isActive) ? "flange flange-active " + props.data.group : "flange " + props.data.group} title={props.data.fen}
      onClick={() => props.onClick(props.data.item)}
      id={props.name} >
      {props.children}
    </div>
  )
}